import request from '@/utils/request';

export async function login(requestData) {
  return request('/drm/ding/applicantFr/login', {
    method: 'POST',
    body: requestData,
  });
}

export async function getRegdtls(requestData) {
  return request('/drm/ding/applicantFr/getRegdtls', {
    method: 'POST',
    body: requestData,
  });
}

export async function updateKYCdetails(requestData) {
  return request('/drm/ding/applicantFr/updateKYCdetails', {
    method: 'POST',
    body: requestData,
  });
}

export async function listKYCdetails(requestData) {
  return request('/drm/ding/applicantFr/listKYCdetails', {
    method: 'POST',
    body: requestData,
  });
}

export async function updateProposaldetails(requestData) {
  return request('/drm/ding/applicantFr/updateProposaldetails', {
    method: 'POST',
    body: requestData,
  });
}

export async function addMember(requestData) {
  return request('/drm/ding/applicantFr/addMember', {
    method: 'POST',
    body: requestData,
  });
}

export async function listMembers(requestData) {
  return request('/drm/ding/applicantFr/listMembers', {
    method: 'POST',
    body: requestData,
  });
}
